<template>
  <div class="site" @mousemove="onMouseMove">
    <div class="progress" :style="{ width: `${scrollProgress}%` }"></div>
    <div class="bg-orb orb-1"></div>
    <div class="bg-orb orb-2"></div>
    <div class="bg-grid"></div>
    <div class="bg-particles">
      <span v-for="i in 16" :key="i" :style="particleStyle(i)"></span>
    </div>

    <header class="topbar">
      <div class="brand-wrap">
        <p class="brand-sub">安徽云汐网络科技有限公司</p>
        <div class="brand">禅意社</div>
      </div>
      <nav class="nav">
        <a href="#home">首页</a>
        <a href="#about">公司介绍</a>
        <a href="#services">产品服务</a>
        <a href="#compliance">合规安全</a>
        <a href="#contact">联系方式</a>
        <a href="#privacy">隐私政策</a>
      </nav>
    </header>

    <section id="home" class="hero section reveal" :style="heroStyle">
      <div class="hero-text">
        <p class="kicker">东方文化数字化产品 · 情绪陪伴型应用</p>
        <h1>心安便是归处 <span class="glow-word">让每次祈愿被温柔记录</span></h1>
        <p>
          禅意社围绕“静心、祈愿、记录、陪伴”构建沉浸式产品体验，
          通过视觉、音效和互动反馈帮助用户获得更稳定的情绪状态与仪式感体验。
        </p>
        <div class="hero-actions">
          <a class="btn primary" href="#services">查看功能矩阵</a>
          <a class="btn ghost" href="#compliance">查看合规能力</a>
        </div>
        <div class="hero-metrics">
          <div v-for="item in metrics" :key="item.label" class="metric">
            <strong>{{ item.value }}</strong>
            <span>{{ item.label }}</span>
          </div>
        </div>
      </div>

      <div class="hero-images">
        <div class="phone-card floating fast tilt">
          <img src="/home-screen-new.png" alt="禅意社应用首页新版" />
        </div>
        <div class="phone-card floating slow tilt">
          <img src="/detail-screen-new.png" alt="禅意社应用详情页新版" />
        </div>
      </div>
    </section>

    <section id="about" class="section card reveal">
      <div class="title-row">
        <h2>公司介绍</h2>
        <span class="tag">About Us</span>
      </div>
      <p>
        安徽云汐网络科技有限公司专注于文化内容与移动互联网产品融合创新，
        以用户体验、内容价值、信息安全为核心，持续打造长期可运营的数字文化产品。
      </p>
      <div class="timeline">
        <div v-for="item in timeline" :key="item.year" class="timeline-item">
          <span class="year">{{ item.year }}</span>
          <div>
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <section id="services" class="section card reveal">
      <div class="title-row">
        <h2>产品 / 服务介绍</h2>
        <span class="tag">Product & Service</span>
      </div>
      <div class="grid">
        <article v-for="item in services" :key="item.title" class="service-card">
          <h3>{{ item.title }}</h3>
          <p>{{ item.desc }}</p>
        </article>
      </div>
      <div class="flow">
        <div class="flow-item" v-for="step in flow" :key="step.step">
          <span>{{ step.step }}</span>
          <h3>{{ step.title }}</h3>
          <p>{{ step.desc }}</p>
        </div>
      </div>
    </section>

    <section id="compliance" class="section card reveal">
      <div class="title-row">
        <h2>合规与安全</h2>
        <span class="tag">Compliance</span>
      </div>
      <div class="legal-grid">
        <article v-for="item in legal" :key="item.title" class="legal-card">
          <h3>{{ item.title }}</h3>
          <p>{{ item.desc }}</p>
        </article>
      </div>
      <div class="notice">
        <p>
          温馨提示：禅意社定位为文化体验与情绪放松工具，不提供医疗诊断、心理治疗或封建迷信相关服务。
          如遇心理健康危机，请及时联系专业医疗机构或当地应急服务。
        </p>
      </div>
    </section>

    <section id="contact" class="section card reveal">
      <div class="title-row">
        <h2>联系方式</h2>
        <span class="tag">Contact</span>
      </div>
      <div class="contact-grid">
        <div class="contact-item">
          <span>公司名称</span>
          <strong>安徽云汐网络科技有限公司</strong>
        </div>
        <div class="contact-item">
          <span>联系电话</span>
          <strong>13817764756</strong>
        </div>
        <div class="contact-item">
          <span>联系邮箱</span>
          <strong>postmaster@chanyishe.cn</strong>
        </div>
        <div class="contact-item">
          <span>投诉与举报受理邮箱</span>
          <strong>postmaster@chanyishe.cn</strong>
        </div>
      </div>
    </section>

    <section id="privacy" class="section card reveal">
      <div class="title-row">
        <h2>隐私政策与用户权益</h2>
        <span class="tag">Privacy & Rights</span>
      </div>
      <div class="privacy-list">
        <p>1. 最小必要：仅收集实现核心功能所需信息，不因拒绝非必要权限而拒绝基础服务。</p>
        <p>2. 明示同意：在收集前明确告知目的、方式、范围及保存期限，取得用户授权后处理。</p>
        <p>3. 权限管理：相机、相册、通知等权限按需弹窗，用户可在系统设置中随时关闭。</p>
        <p>4. 用户权利：支持查询、更正、删除个人信息及注销账号，申请路径在 App 内清晰可见。</p>
        <p>5. 未成年人保护：设置未成年人模式与内容分级提示，禁止诱导充值与不当营销。</p>
        <p>6. 第三方共享：如接入第三方 SDK，将在《第三方信息共享清单》中逐项披露。</p>
        <p>7. 跨境与存储：个人信息在境内存储；如涉及跨境处理，将依法单独告知并取得单独同意。</p>
      </div>
      <div class="record-box">
        <p><strong>备案与公示信息</strong></p>
        <p>
          ICP 备案号：
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer noopener">
            皖ICP备2026015980号-1
          </a>
        </p>
        <p>公安网安备案号：待取得后公示</p>
        <p>更新时间：2026年5月29日</p>
      </div>
    </section>

    <footer class="footer">
      <p>© {{ year }} 安徽云汐网络科技有限公司 保留所有权利</p>
      <p class="record-line">
        ICP 备案号：
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer noopener">
          皖ICP备2026015980号-1
        </a>
      </p>
    </footer>
  </div>
</template>

<script setup>
import { computed, onMounted, onUnmounted, ref } from 'vue'

const year = new Date().getFullYear()
const mouseX = ref(0.5)
const mouseY = ref(0.5)
const scrollProgress = ref(0)

const metrics = [
  { value: '7 x 24', label: '陪伴场景可用' },
  { value: '6+', label: '核心功能模块' },
  { value: '100%', label: '隐私条款公开' }
]

const timeline = [
  { year: '2024', title: '产品立项', desc: '完成场景定义与首版体验设计。' },
  { year: '2025', title: '体验升级', desc: '完善静心与记录流程，优化交互反馈。' },
  { year: '2026', title: '品牌官网升级', desc: '上线合规导向官网，强化公开透明与服务触达。' }
]

const services = [
  { title: '静心交互体验', desc: '围绕静心按钮、动态反馈与仪式流程建立沉浸式体验。' },
  { title: '心愿记录体系', desc: '支持用户记录愿望、查看历史，形成连续陪伴与复盘。' },
  { title: '文化内容运营', desc: '基于节气与传统文化主题，持续更新图文与互动活动。' },
  { title: '会员与活动系统', desc: '提供活动提醒、权益说明及透明的付费规则展示。' },
  { title: '数据分析支持', desc: '对核心行为进行匿名统计，支持产品优化与服务改进。' },
  { title: '客服与反馈闭环', desc: '建立问题反馈、投诉处理与响应时效机制。' }
]

const flow = [
  { step: '01', title: '进入静心场景', desc: '通过首页入口进入沉浸式静心空间。' },
  { step: '02', title: '完成互动行为', desc: '进行祈愿、敲击、记录等核心互动。' },
  { step: '03', title: '沉淀个人记录', desc: '查看历史记录与阶段变化，形成长期陪伴感。' },
  { step: '04', title: '获取运营内容', desc: '按主题接收活动内容，提升持续参与。' }
]

const legal = [
  { title: '个人信息保护法合规', desc: '遵循合法、正当、必要和诚信原则，建立用户授权与撤回机制。' },
  { title: '网络安全与数据安全治理', desc: '建立访问控制、日志审计、传输加密与安全巡检制度。' },
  { title: '必要个人信息范围管理', desc: '核心功能可在最小信息前提下运行，不强制索取无关权限。' },
  { title: '未成年人网络保护', desc: '落实未成年人使用提示、时间管理与不良信息防护策略。' },
  { title: '算法与推荐透明', desc: '如使用个性化推荐，提供关闭入口并公示基本规则。' },
  { title: '投诉举报机制', desc: '公开联系方式，按流程受理用户申诉、投诉与删除请求。' }
]

const onMouseMove = (event) => {
  mouseX.value = event.clientX / window.innerWidth
  mouseY.value = event.clientY / window.innerHeight
}

const onScroll = () => {
  const scrollTop = window.scrollY
  const pageHeight = document.documentElement.scrollHeight - window.innerHeight
  scrollProgress.value = pageHeight > 0 ? (scrollTop / pageHeight) * 100 : 0
}

const heroStyle = computed(() => ({
  '--mx': `${mouseX.value}`,
  '--my': `${mouseY.value}`
}))

const particleStyle = (i) => ({
  left: `${(i * 7) % 100}%`,
  animationDelay: `${i * 0.7}s`,
  animationDuration: `${7 + (i % 5)}s`
})

onMounted(() => {
  window.addEventListener('scroll', onScroll, { passive: true })
  onScroll()
})

onUnmounted(() => {
  window.removeEventListener('scroll', onScroll)
})
</script>
